export default __webpack_public_path__ + "static/media/xt-logo.c196da91.jpg";